import { render, staticRenderFns } from "./cn2051.vue?vue&type=template&id=8b0297fe&scoped=true&"
import script from "./cn2051.vue?vue&type=script&lang=js&"
export * from "./cn2051.vue?vue&type=script&lang=js&"
import style0 from "./cn2051.vue?vue&type=style&index=0&id=8b0297fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0297fe",
  null
  
)

export default component.exports